export default [{
  path: '/workType',
  name: 'workType',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/workType/index')
}]
